import { launchCamera, launchImageLibrary, } from 'react-native-image-picker';
import DP from 'react-native-document-picker';
import { Alert, Linking, PermissionsAndroid, Platform } from 'react-native';
import { isAndroid } from "../pages/utils";
let Camera, RNVC;
if (Platform.OS !== 'web') {
    RNVC = require('react-native-vision-camera');
    Camera = RNVC.Camera;
}
export const camera = async (item, onCancel, isFromASES) => {
    const askForCameraPermission = async () => {
        if (Camera) {
            const cameraPermission = await Camera.requestCameraPermission();
            if (cameraPermission === 'denied') {
                Alert.alert('This feature requires camera access', 'In iPhone settings, tap voltmoney and turn on camera', [
                    {
                        text: 'Cancel',
                        onPress: () => {
                            onCancel &&
                                onCancel();
                        },
                        style: 'cancel',
                    },
                    {
                        text: 'Open Settings',
                        onPress: () => Linking.openSettings(),
                        style: 'cancel',
                    },
                ], {
                    cancelable: true,
                    onDismiss: () => Alert.alert('This alert was dismissed by tapping outside of the alert dialog.'),
                });
            }
            return cameraPermission;
        }
    };
    switch (item.label) {
        case 'Camera': {
            const launchCameraCallback = (imageObj) => {
                if (imageObj?.didCancel) {
                    onCancel &&
                        onCancel();
                }
            };
            let granted = '';
            if (Platform.OS === 'ios') {
                granted = await askForCameraPermission();
            }
            else {
                granted = await PermissionsAndroid.request(PermissionsAndroid.PERMISSIONS.CAMERA, {
                    title: "App Camera Permission",
                    message: "App needs access to your camera ",
                    buttonNeutral: "Ask Me Later",
                    buttonNegative: "Cancel",
                    buttonPositive: "OK"
                });
            }
            console.log("Camera permission denied granted : ", granted);
            if (granted === PermissionsAndroid.RESULTS.GRANTED || granted === 'authorized') {
                const image = await launchCamera({
                    saveToPhotos: true,
                    mediaType: 'photo',
                    includeBase64: false,
                }, launchCameraCallback);
                return Platform.OS === 'android'
                    ? image.assets[0]
                    : image?.assets[0];
            }
            else {
                if (granted === 'never_ask_again') {
                    Alert.alert('This feature requires camera access', isAndroid()
                        ? 'In phone settings, tap voltmoney and turn on camera'
                        : 'In iPhone settings, tap voltmoney and turn on camera', [
                        {
                            text: 'Cancel',
                            onPress: () => {
                                onCancel &&
                                    onCancel();
                            },
                            style: 'cancel',
                        },
                        {
                            text: 'Open Settings',
                            onPress: () => {
                                onCancel &&
                                    onCancel();
                                Linking.openSettings();
                            },
                            style: 'cancel',
                        },
                    ], {
                        cancelable: true,
                        onDismiss: () => Alert.alert('This alert was dismissed by tapping outside of the alert dialog.'),
                    });
                }
                console.log("Camera permission denied");
                onCancel && onCancel();
            }
            break;
        }
        case 'Gallery': {
            const image = await launchImageLibrary({
                mediaType: 'photo',
                includeBase64: false,
            });
            if (image?.didCancel) {
                // handle cancel here
                onCancel &&
                    onCancel();
            }
            return image.assets[0];
        }
        case 'File': {
            try {
                const file = await DP.pick({
                    type: isFromASES ?
                        [
                            DP.types.pdf,
                            DP.types.images
                        ] : [
                        DP.types.pdf,
                        DP.types.doc,
                        DP.types.images,
                    ],
                    presentationStyle: 'fullScreen',
                });
                return file[0];
            }
            catch (err) {
                if (DP.isCancel(err)) {
                    // handle cancel here
                    onCancel &&
                        onCancel();
                }
                else {
                    //For Unknown Error
                    console.log('Exception error cancelled: ' + JSON.stringify(err));
                }
            }
        }
    }
};
